// extracted by mini-css-extract-plugin
export var green = "layout-module--green--e8ee3";
export var main = "layout-module--main--6b2f2";
export var wrapper = "layout-module--wrapper--e545e";